import React from "react";

import { Typography } from "@material-ui/core";

const Help = () => (
  <>
    <Typography variant="subtitle1">
      Use the Document Repository to upload important documnets which you need
      to quickly find and identity. For instance, you can upload MSDS sheets or
      other Safety documents and instructions which need to be easily accessible
      by the Crews in the field.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Upload File: </strong>
          Drop a File or click to select and attach.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Display Name: </strong>
          Document name to be displayed in the Document Repository. Defaults to
          raw file name, but we recommend using a more descriptive, short name.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Document Category: </strong>
          Optional - group your documents into distinct categories. You can add
          new Category directly from the dropdown, by selecting "Add new
          category...", or from the ATTACHMENTS tab in My Yard setup.
        </Typography>
      </li> 
      <li>
        <Typography>
          <strong>Description: </strong>
          Searchable notes applicable to this document. Include keywords which
          you might use in the future when searching for this document.
        </Typography>
      </li>
    </ul>
  </>
);

export const FileHelp = ({ ...props }) => {
  var { location } = props;
  var tabIdx = /[^/]*$/.exec(location.pathname)[0];
  var tab = tabIdx.length === 1 ? tabIdx : "0";

  switch (tab) {
    case "0":
      return <Help />;
    default:
      return null;
  }
};
